export enum FeedPostLikeStatus {
    DELETED = 0,
    ACTIVE = 1
}